import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/map';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { Priority } from '../../model/priority/types';
import {
	PRIORITY_SEARCH_API_ENDPOINT,
	DEPRECATED_PRIORITY_ENDPOINT,
	ALL_PRIORITIES_DATA_OPERATION_NAME,
	ALL_PRIORITIES_QUERY,
} from './constants';
import type { FetchAllPrioritiesResponse, PriorityResponseOld } from './types';

/**
 * @deprecated
 *  This is deprecated use {@link transformer} instead.
 *  TODO: Clean up transformerOld when cleaning up 'priorities.per.project.backlog-contextual-menu' feature flag
 */
const transformerOld = (priorities: PriorityResponseOld[]): Priority[] =>
	priorities.map((priority: PriorityResponseOld) => ({
		id: priority.id,
		name: priority.name,
		iconUrl: priority.iconUrl,
	}));

export const transformer = (priorities: FetchAllPrioritiesResponse): Priority[] => {
	const allPriorities = priorities.data.jira.jiraProjects.map((project) =>
		project.priorityScheme.priorities.edges.map((edge) => ({
			id: edge.node.priorityId,
			name: edge.node.name,
			iconUrl: edge.node.iconUrl,
		})),
	);
	const intersectingPriorities = allPriorities.reduce((prioritiesA, prioritiesB) =>
		prioritiesA.filter((priorityA) =>
			prioritiesB.some((priorityB) => priorityA.id === priorityB.id),
		),
	);

	return intersectingPriorities;
};

export const fetchAllPriorities = (projectIds: string[]): ObservableType<Priority[]> =>
	fetchJson$<FetchAllPrioritiesResponse>(
		`${PRIORITY_SEARCH_API_ENDPOINT}?operation=${ALL_PRIORITIES_DATA_OPERATION_NAME}`,
		{
			method: 'post',
			body: JSON.stringify({
				query: ALL_PRIORITIES_QUERY,
				variables: {
					projectIds,
				},
			}),
		},
	).map(transformer);

/**
 * @deprecated
 *  This is deprecated use {@link fetchAllPriorities} instead.
 *  TODO: Clean up fetchPriorities when cleaning up 'priorities.per.project.backlog-contextual-menu' feature flag
 */
export const fetchPriorities = (): ObservableType<Priority[]> =>
	fetchJson$<PriorityResponseOld[]>(DEPRECATED_PRIORITY_ENDPOINT).map(transformerOld);
